export const en = {
  navigation: {
    home: 'Home',
    aboutUs: 'About Us',
    ourWork: 'Our Work',
    ourServices: 'Services',
    ourProcess: 'Process',
    recognitions: 'Recognitions',
    newIdeas: 'New Projects',
  },
  hero: {
    title: 'What is our work?',
    subtitle: 'Discover Amazing Applications',
    description: 'We are a technology company specialized in developing custom digital solutions. Over the years we have made different contributions in various fields.',
    innovation: 'All our work has a high degree of innovation focused on the design of tools designed to facilitate the user experience.',
    sectorsIntro: 'We have collaborated with companies in the creation of tools for specialized sectors, such as:',
    sectors: {
      biotech: 'Biotechnology',
      mentalHealth: 'Mental health care',
      music: 'Music sector',
      transport: 'Transportation',
      realEstate: 'Real estate',
      agropharmaceutical: 'Agropharmaceutical',
      general: 'Business in general'
    },
    closing: 'We drive the growth of your company through technology.'
  },
  aboutUs: {
    title: 'About Us',
    presence: {
      title: 'Colombia, our home base',
      description: 'We are a software development company based primarily in Colombia, where we have built most of our projects over the years.'
    },
    expansion: {
      title: 'Opening the Spanish market',
      description: 'We are currently opening a market in Spain, where we support the web development of TCG Madrid and take part in project planning for Apptivities alongside the City Council of Madrid.'
    },
    team: {
      title: 'A small, specialized team',
      description: 'We have two full-time developers, and we bring in additional talent based on the needs of each project and client.'
    },
    locations: {
      colombia: 'Colombia',
      spain: 'Spain'
    }
  },
  features: {
    title: 'Applications ideas',
    description: 'Our applications are the reflection of personal tastes and the feeling of solving problems and creating new things.',
    items: {
      feature1: 'Native applications',
      feature2: 'Hybrid applications',
      feature3: 'Web applications',
    },
    summary: 'Ideas made applications where you can express yourself creatively.',
    images: {
      chart: 'Statistics dashboard',
      calendar: 'Calendar view',
      graph: 'Analytics graph',
      metrics: 'Performance metrics'
    },
    summary2: 'Project developed in the transportation sector that facilitates quick calculations to obtain simple but useful data.',
  },
  worldPotential: {
    title: "Recognitions",
    description: "Music Creator has been a winner at the HMS App Innovation Contest in the 2021 version. Melody Creator was a finalist in the 2019 Huawei app awards.",
    description2: "Melody Creator was a finalist in the 2019 Huawei app awards.",
    items: {
      item1: "Innovation in applications",
      item2: "Added features to make the application a more complete tool",
      item3: "Intuitive and easy-to-use user interface",
      item4: "Constant updates",
      item5: "Improving the user experience"
    },
    summary: "Currently, our applications like Songs Creator and Melody Creator have reached up to 500,000 downloads, which is a great achievement. Likewise, thanks to the passion for software development, curiosity, ideas, and with a fundamental ingredient that is continuous improvement, we can conclude that the technological world is full of adventures and possibilities.",
    images: {
      worldMap: "World map statistics",
      lineChart: "Growth chart",
      usMap: "US map data"
    }
  },
  ourWork: {
    title: "Our Work",
    subtitle: "Innovative projects that transform ideas into real solutions",
    projects: {
      musicalArea: {
        title: "Musical Area",
        description: "Starting as a startup in 2016, we helped DMB Mobile Apps grow the Melody Creator application to become a widely used application with 500,000 downloads today. From this we also helped develop two more applications, Music Creator and Rhythm Creator, with good reception that are currently attracting users.",
        location: "Colombia",
        highlights: [
          "Applications developed in native language to support all audio features.",
          "Currently available in Google Play."
        ],
      },
      realEstate: {
        title: "Real Estate Administration",
        description: "In collaboration with LONJA, a system for evaluating and certifying horizontal property administrators was designed.",
        location: "Colombia, United States",
        highlights: [
          "Agile system, with reduced evaluation times and creation of personalized templates."
        ]
      },
      mentalHealth: {
        title: "Mental Health Care",
        description: "Design and implementation of telehealth platforms; unified clinical history, appointment management with professionals and platforms with effective UX. These tools allowed better care times and market expansion through digital media.",
        location: "Colombia",
        highlights: [
          "Development of applications for clinical monitoring and mental wellness.",
          "Compliance with health regulations in Colombia."
        ]
      },
      biotech: {
        title: "Biotechnology",
        description: "With our support in the Biotechnology sector, the application for obtaining data and analysis of an automatic covid-19 diagnostic device was improved.",
        location: "United States",
        highlights: [
          "Improves the infrastructure and configuration of cloud services of the company.",
          "Cost reduction of 40% and optimizing resources for sample analysis."
        ]
      },
      zonari: {
        title: "Zonari — Parking Management",
        description: "Zonari is our newly launched SaaS platform in Colombia for managing parking in residential complexes, with role-based access control for administrators, residents, and authorized users.",
        location: "Colombia",
        highlights: [
          "Real-time access management and auditing.",
          "Secure, scalable cloud infrastructure."
        ]
      },
      tcgmadrid: {
        title: "TCG Madrid — Specialty Store",
        description: "We support the development of TCG Madrid's online store, a leading trading card retailer (Magic, Pokémon, One Piece) in Spain, with a catalog, authenticity checks, and tournament management.",
        location: "Spain",
        highlights: [
          "E-commerce platform with catalog and shipping across Spain.",
          "Our first web development project in the Spanish market."
        ]
      },
      apptivities: {
        title: "Apptivities — AI Activity Planning",
        description: "We collaborate on the planning of the Apptivities project, an AI-powered application for creating personalized leisure itineraries, in coordination with the City Council of Madrid.",
        location: "Spain",
        highlights: [
          "AI-generated itineraries in minutes instead of hours.",
          "A key project in our expansion into Spain."
        ]
      }
    }
  },
  ourProcess: {
    title: "Our Process",
    steps: {
      step1: {
        title: "Step 1",
        description: "Analysis of needs and requirements gathering with expert staff"
      },
      step2: {
        title: "Step 2",
        description: "Generation of personalized quote and validation with the client"
      },
      step3: {
        title: "Step 3",
        description: "Development and progress validation through continuous periodic reviews with our clients"
      },
      step4: {
        title: "Step 4",
        description: "Final delivery and implementation verification"
      },
      step5: {
        title: "Step 5",
        description: "Support and follow-up service"
      }
    }
  },
  ourServices: {
    title: "Our Services",
    services: {
      software: {
        title: "Software Development",
        description: "Customized solutions tailored to your specific needs"
      },
      mobile: {
        title: "Mobile Applications",
        description: "Development of native and multiplatform apps"
      },
      cloud: {
        title: "Cloud Services",
        description: "Scalable and secure cloud solutions"
      },
      itSupport: {
        title: "IT Services Administration and Support",
        description: "We adapt your infrastructure to your company's needs, saving time and resources."
      },
      consulting: {
        title: "Technology Consulting and Advisory",
        description: "Advice on the selection and application of technologies that optimize your company's performance."
      }
    }
  },
  footer: {
    trial: {
      title: 'What ideas turned into applications are coming?',
      description: 'We will be showing you new projects very soon.',
      button: 'Contact us'
    },
    sections: {
      legal: {
        title: 'LEGAL',
        privacy: 'Privacy Policy',
        licensing: 'Licensing',
        terms: 'Terms'
      }
    }
  },
  legal: {
    tocLabel: 'Table of Contents',
    backToTop: '↑ Back to top'
  },
  cookieBanner: {
    ariaLabel: 'Cookie notice',
    message: "This site does not use tracking, advertising, or analytics cookies. We only use your browser's local storage to remember that you've seen this notice.",
    learnMore: 'Learn more',
    acknowledge: 'Got it'
  },
  privacyPolicy: {
    title: 'Privacy Policy',
    lastUpdated: 'Last updated: September 9, 2026',
    sections: [
      {
        id: 'responsibleParty',
        heading: 'Data Controller',
        paragraphs: [
          "This Privacy Policy applies to the corporate website of JBP Software SAS (\"JBP Software\", \"we\", or \"the company\"), a software development company headquartered in Colombia with a growing commercial presence in Spain.",
          "The controller responsible for the personal data collected through this site is JBP Software SAS. For any questions about this policy, you can write to us at jbp.software.sas@gmail.com."
        ]
      },
      {
        id: 'dataCollected',
        heading: 'Information We Collect',
        paragraphs: [
          "This website is a corporate presentation site and currently does not have registration forms, user accounts, or active analytics/tracking cookies.",
          "The only personal data we collect is what you voluntarily choose to share with us when you contact us, for example:"
        ],
        list: [
          "Your name, email address, and the content of your message when you write to our contact email (jbp.software.sas@gmail.com).",
          "Your phone number and the content of the conversation when you reach out through the WhatsApp button available on the site.",
          "Basic technical data that our hosting provider may automatically log when you visit the site (such as IP address or browser type), used solely for the security and operation of the service."
        ]
      },
      {
        id: 'useOfData',
        heading: 'How We Use Your Information',
        paragraphs: [
          "We use the information you share with us exclusively to:"
        ],
        list: [
          "Respond to your business or technical inquiries.",
          "Follow up on requests for quotes or software development services.",
          "Maintain communication with you about an ongoing project or business relationship."
        ]
      },
      {
        id: 'dataSharing',
        heading: 'Who We Share Information With',
        paragraphs: [
          "We do not sell, rent, or transfer your personal data to third parties for commercial purposes.",
          "When you write to us on WhatsApp, the conversation is processed through WhatsApp/Meta's infrastructure, which acts as the messaging channel provider and handles the information under its own privacy policy.",
          "We may disclose personal information when strictly necessary to comply with a legal obligation or a request from a competent authority."
        ]
      },
      {
        id: 'dataRetention',
        heading: 'Data Retention',
        paragraphs: [
          "We retain the information you share with us only for as long as necessary to handle your request or maintain the corresponding business relationship, and afterward for the period required by applicable law. Once its purpose has been fulfilled, we take steps to securely delete or anonymize it."
        ]
      },
      {
        id: 'security',
        heading: 'Security of Your Information',
        paragraphs: [
          "We apply reasonable technical and organizational security measures to protect the personal information we handle against unauthorized access, loss, or misuse. However, no electronic transmission or storage method is completely infallible, so we cannot guarantee absolute security."
        ]
      },
      {
        id: 'rights',
        heading: 'Your Rights as a Data Subject',
        paragraphs: [
          "If you are located in Colombia, you have the rights recognized under Law 1581 of 2012 and Decree 1377 of 2013 (Colombia's personal data protection regime — Habeas Data), including the right to:"
        ],
        list: [
          "Know, update, and correct your personal data.",
          "Request proof of the authorization granted for the processing of your data, where applicable.",
          "Request the deletion of your data when its processing fails to respect constitutional or legal principles, rights, and guarantees.",
          "Revoke the authorization granted for the processing of your personal data.",
          "File complaints with the Superintendencia de Industria y Comercio for violations of data protection regulations."
        ]
      },
      {
        id: 'euReference',
        heading: 'Visitors from Spain and the European Union',
        paragraphs: [
          "As we expand our business activity into Spain, if you visit or contact us from Spain or any European Union country, we aim to apply principles equivalent to those set out in the General Data Protection Regulation (GDPR) and Spain's Organic Law 3/2018 on the Protection of Personal Data and the guarantee of digital rights (LOPDGDD), particularly regarding lawfulness, data minimization, and transparency in the processing of your data.",
          "If you believe your rights under this regulation have not been respected, you can contact us directly using the email provided in this policy before approaching the relevant supervisory authority."
        ]
      },
      {
        id: 'minors',
        heading: 'Minors',
        paragraphs: [
          "This website is aimed at a business and professional audience and is not designed for use by minors. We do not knowingly collect personal information from individuals under 18 years of age. If you become aware that a minor has provided us with personal data, please contact us so we can remove it."
        ]
      },
      {
        id: 'internationalTransfers',
        heading: 'International Data Transfers',
        paragraphs: [
          "As part of our expansion into Spain, the information you share may be processed or stored in Colombia, Spain, or on servers of cloud service providers located in other countries. In these cases, we take reasonable steps to ensure that such data receives an adequate level of protection in accordance with the regulations applicable in each jurisdiction."
        ]
      },
      {
        id: 'changes',
        heading: 'Changes to This Policy',
        paragraphs: [
          "We may update this Privacy Policy to reflect changes in our practices, our services, or applicable regulations. The date of the last update is indicated at the top of this document. We encourage you to review this page periodically."
        ]
      },
      {
        id: 'cookies',
        heading: 'Cookies and Local Storage',
        paragraphs: [
          "This website does not use tracking, advertising, or analytics cookies, and we do not collect browsing data for statistical or marketing purposes.",
          "We use your browser's local storage only to remember that you have already seen the cookie notice on this site, so it doesn't appear again on future visits. This information stays on your device and is never sent to our servers or any third party."
        ]
      },
      {
        id: 'contact',
        heading: 'Contact',
        paragraphs: [
          "If you have questions about this Privacy Policy or about the processing of your personal data, you can write to us at jbp.software.sas@gmail.com."
        ]
      }
    ]
  },
  termsAndConditions: {
    title: 'Terms and Conditions',
    lastUpdated: 'Last updated: September 9, 2026',
    sections: [
      {
        id: 'acceptance',
        heading: 'Acceptance of Terms',
        paragraphs: [
          "By accessing and using the JBP Software SAS website (\"the site\"), you fully accept these Terms and Conditions. If you do not agree with any of these terms, please refrain from using the site."
        ]
      },
      {
        id: 'purpose',
        heading: 'Purpose of the Site',
        paragraphs: [
          "This site aims to present JBP Software SAS, a software development company based in Colombia with a growing commercial presence in Spain, and to showcase its services, work process, and representative projects (\"Our Work\").",
          "The information published on the site is for informational purposes and does not constitute a binding commercial offer or a service agreement; any contractual relationship with JBP Software SAS will be formalized through specific agreements with each client."
        ]
      },
      {
        id: 'permittedUse',
        heading: 'Permitted Use of the Site',
        paragraphs: [
          "You agree to use the site lawfully and to refrain from:"
        ],
        list: [
          "Using the site for fraudulent, unlawful, or bad-faith purposes.",
          "Attempting to compromise the site's security or access restricted areas without authorization.",
          "Reproducing, copying, or distributing content from the site for commercial purposes without prior authorization."
        ]
      },
      {
        id: 'intellectualProperty',
        heading: 'Intellectual Property',
        paragraphs: [
          "The content on this site (text, images, logos, design, and source code) is owned by JBP Software SAS or its licensors and is protected by applicable intellectual property laws. Reproduction, distribution, or modification of this content, in whole or in part, is prohibited without the prior written authorization of JBP Software SAS."
        ]
      },
      {
        id: 'thirdPartyBrands',
        heading: 'Third-Party Brands and Projects',
        paragraphs: [
          "In the \"Our Work\" section, we mention and display logos of clients and projects we have collaborated on, such as TCG Madrid, Apptivities, and Zonari, among others. Third-party trademarks, trade names, and logos are the property of their respective owners and are displayed solely for demonstrative and informational purposes as part of our portfolio, without implying any affiliation, sponsorship, or endorsement unless expressly stated."
        ]
      },
      {
        id: 'thirdPartyLinks',
        heading: 'Third-Party Links and Services',
        paragraphs: [
          "The site includes a direct link to WhatsApp to facilitate contacting us. This service is operated by a third party (Meta), and its use is subject to that provider's own terms and policies, over which we have no control or responsibility."
        ]
      },
      {
        id: 'accuracy',
        heading: 'Accuracy of Information',
        paragraphs: [
          "We strive to keep the information on the site accurate and up to date, but we do not guarantee that it will always be free of errors, complete, or current at all times. Published information may be changed without prior notice."
        ]
      },
      {
        id: 'liability',
        heading: 'Limitation of Liability',
        paragraphs: [
          "To the extent permitted by law, JBP Software SAS will not be liable for direct or indirect damages arising from the use or inability to use the site, including service interruptions, errors or omissions in content, or the use of links to third-party sites."
        ]
      },
      {
        id: 'governingLaw',
        heading: 'Governing Law and Jurisdiction',
        paragraphs: [
          "These Terms and Conditions are governed by the laws of the Republic of Colombia, the country where JBP Software SAS is primarily domiciled. For specific commercial relationships with clients located in Spain or other countries, additional contractual terms may be agreed upon that take into account applicable local regulations."
        ]
      },
      {
        id: 'changes',
        heading: 'Changes to These Terms',
        paragraphs: [
          "We may update these Terms and Conditions at any time to reflect changes in our services or applicable regulations. The date of the last update is indicated at the top of this document."
        ]
      },
      {
        id: 'contact',
        heading: 'Contact',
        paragraphs: [
          "If you have questions about these Terms and Conditions, you can write to us at jbp.software.sas@gmail.com."
        ]
      }
    ]
  }
};
